import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { pincodeData } from "../utils/pincodeData";

// The state can be controlled by the parent (`state` + `onStateChange`), as
// the patient form does to keep it as a field of its own.
const PincodeSelector = ({ setSelectedPincode, state, onStateChange, stateError }) => {
  const locationData = pincodeData;
  const controlled = typeof onStateChange === "function";
  const [ownState, setOwnState] = useState("");
  const selectedState = controlled ? state || "" : ownState;
  const setSelectedState = controlled ? onStateChange : setOwnState;
  // A state from ABHA/Aadhaar may be missing from the pincode list.
  const districts = (selectedState && locationData[selectedState]) || null;
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedPO, setSelectedPO] = useState("");
  const [pincode, setPincode] = useState("");

  useEffect(() => {
    if (pincode) {
      setSelectedPincode(pincode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pincode]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl fullWidth error={Boolean(stateError)}>
            <InputLabel>State</InputLabel>
            <Select
              value={selectedState}
              onChange={(e) => {
                setSelectedState(e.target.value);
                setSelectedDistrict("");
                setSelectedPO("");
                setPincode("");
              }}
            >
              <MenuItem value=''>Select State</MenuItem>
              {selectedState && !districts && (
                <MenuItem value={selectedState}>{selectedState}</MenuItem>
              )}
              {Object.keys(locationData).sort().map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
            {stateError && <FormHelperText>{stateError}</FormHelperText>}
          </FormControl>
        </Grid>

        <Grid item xs={4}>
          {districts && (
            <FormControl fullWidth>
              <InputLabel>District</InputLabel>
              <Select
                value={selectedDistrict}
                onChange={(e) => {
                  setSelectedDistrict(e.target.value);
                  setSelectedPO("");
                  setPincode("");
                }}
              >
                <MenuItem value=''>Select District</MenuItem>
                {Object.keys(districts).sort().map((district) => (
                  <MenuItem key={district} value={district}>
                    {district}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Grid>

        <Grid item xs={4}>
          {districts && selectedDistrict && (
            <FormControl fullWidth>
              <InputLabel>P.O.</InputLabel>
              <Select
                value={selectedPO}
                onChange={(e) => {
                  const po = e.target.value;
                  setSelectedPO(po);
                  setPincode(
                    locationData[selectedState][selectedDistrict][po]
                  );
                }}
              >
                <MenuItem value=''>Select PO</MenuItem>
                {Object.keys(locationData[selectedState][selectedDistrict]).sort().map(
                  (po) => (
                    <MenuItem key={po} value={po}>
                      {po}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PincodeSelector;
